const SHARE_TITLE = "Home address";

export function formatHouseholdShareText(residentName: string, address: string): string {
  const name = residentName.trim();
  const line = address.trim();
  if (name && line) return `${name}\n${line}`;
  return line || name;
}

export function getWhatsAppShareUrl(text: string): string {
  return `https://wa.me/?text=${encodeURIComponent(text)}`;
}

export function getSmsShareUrl(text: string): string {
  return `sms:?&body=${encodeURIComponent(text)}`;
}

export function getGoogleMapsShareUrl(address: string): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address.trim())}`;
}

export function isNativeShareAvailable(text: string): boolean {
  if (typeof navigator === "undefined" || typeof navigator.share !== "function") {
    return false;
  }

  if (typeof navigator.canShare !== "function") {
    return true;
  }

  try {
    return navigator.canShare({text: text, title: SHARE_TITLE});
  } catch {
    return false;
  }
}

export async function shareHouseholdAddressNative(text: string): Promise<"shared" | "cancelled" | "failed"> {
  if (!isNativeShareAvailable(text)) {
    return "failed";
  }

  try {
    await navigator.share({title: SHARE_TITLE, text});
    return "shared";
  } catch (error) {
    if (error instanceof DOMException && error.name === "AbortError") {
      return "cancelled";
    }
    return "failed";
  }
}

export async function copyHouseholdAddress(text: string): Promise<boolean> {
  if (typeof navigator === "undefined" || !navigator.clipboard?.writeText) {
    return false;
  }

  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
